var React = require('react');

function IconFacebook (props) {
    return React.createElement("svg",props,[React.createElement("circle",{"cx":"22","cy":"22","r":"21.5","stroke":"var(--color-logo)","strokeOpacity":"0.2","key":0}),React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M22.6548 29H19.551V21.9991H18V19.5868H19.551V18.1386C19.551 16.1708 20.4263 15 22.9147 15H24.9858V17.4132H23.6913C22.7226 17.4132 22.6586 17.7503 22.6586 18.3794L22.6543 19.5868H25L24.7255 21.9991H22.6543V29H22.6548Z","fill":"var(--color-card-text)","key":1})]);
}

IconFacebook.defaultProps = {"width":"44","height":"44","viewBox":"0 0 44 44","fill":"none"};

module.exports = IconFacebook;

IconFacebook.default = IconFacebook;
